module.exports = __webpack_public_path__ + "static/media/2.Pictures-beauty-shop.0d33c839.png";